/*

	CUT AGAIN
	
	JAVASCRIPT
	
	CREATED BY RYAN ILG
	HTTP://RYANILG.COM
	
	CREATED: Wed Nov 17 11:40:22 PST 2010
	LAST UPDATE: Wed Nov 17 11:40:22 PST 2010
	
*/

	$(document).ready(function() {

		/* SWITCHER FOR PRODUCT THUMBNAILS 
		+ + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + */

			// FOR PRODUCT THUMBNAILS
			$('.product-images .thumbs img').each(function(index) {
				$(this).click(function(e) {
					
					// FIND THIS PRODUCTS HERO
					var hero = $(this).parents('.product-images').find('.hero');
					
					// LOAD THE IMAGE
					loadImg(hero, images[index]);
					
					// IF THIS HERO IS ALSO A LINK, CHANGE THE URL TO THAT OF THE THUMBNAIL
					if (hero.attr('href')) { hero.attr('href', $(this).parent().attr('href')); }
					
					// DISABLE DEFAULT ACTIONS
					e.preventDefault();
				});
			});


		/* STYLIZE THE SELECT DROPDOWNS
		+ + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + */
		
			// FOR EACH FORM SELECT
			$('select.form-select').each(function() {
				
				// GET THE TITLE
				var title = $(this).attr('title');
				
				// IF THE VALUE IS NOT BLANK, UPDATE THE TITLE
				if ($('option:selected', this).val() != '') { 
					title = $('option:selected', this).text();
				}
				
				// HIDE THE DEFAULT FORM ELEMENT, AND ADD THE "DESIGNER" VERSION
				$(this)
					.css({ 'z-index': 10, 'opacity': 0, '-khtml-appearance': 'none' })
					.after('<span class="form-select">' + title + '</span>')
					.change(function() {
						val = $('option:selected', this).text();
						$(this).next().text(val);
					});
			});


		/* UPDATE IMAGE ON CARD SELECT DROWDOWNS 
		+ + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + */
		
			// FOR EACH "CARD" SELECT MENU
			$('select.card-select').change(function() {
				
				// FIND THE HERO IMAGE FOR THIS PRODUCT
				var hero = $(this).parents('.product').find('.hero');
				
				// WITH THE SELECTED, CHANGE THE IMAGE BASED ON INDEX
				$('select option:selected').each(function(index) { 
					
					// LOAD THE IMAGE
					loadImg(hero, images[$('option').index(this)+1]);
				});
				
			}).change(); // CHANGE ON LOAD
			
	});


	/* LOAD AN IMAGE INTO A CONTAINER 
	+ + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + + */

		function loadImg(container, path) {
			
			// REFERENCE THE CONTAINER
			var container = $(container);
			
			// HIDE THE CURRENT IMAGE
			container.find('img').animate({ opacity: 0 }, 100 );
			
			// ADD THE LOADING SPINNER
			container.addClass('loading');
			
			// CREATE THE IMAGE OBJECT TO LOAD INTO
			var img = new Image();
			
			// UPON COMPLETION OF LOADING
			$(img).load(function() {
				
				// ADD THE IMAGE TO THE CONTAINER
				container.html($(img));
				
				// REMOVE THE LOADING SPINNER
				container.removeClass('loading');
				
				// FADE THE NEW IMAGE IN
				container.css("opacity", "0");
				container.animate({ opacity: 1 }, 300);
				
			})
			
			// GIVE AN ERROR MESSAGE IF THERE IS A PROBLEM
			.error(function() {
				console.log("Error loading image: " + path);
			})
			
			// SET THE SOURCE OF THE IMAGE TO BE LOADED
			.attr('src', path);
		}
	